<template>
  <div class="container" >

    <div class="form">
      <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
        <el-row>
          <el-col :span="4">
            <el-form-item label="疾病状态" prop="diseaseStatus">
              <el-select v-model="form.diseaseStatus" clearable placeholder="请选择疾病状态">
                <el-option v-for="item in dietIbdCategory"
                           :key="item.dictKey"
                           :label="item.dictValue"
                           :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="疾病程度" prop="diseaseSeverity">
              <el-select v-model="form.diseaseSeverity" clearable placeholder="请选择疾病程度">
                <el-option v-for="item in dietIbdStage"
                           :key="item.dictKey"
                           :label="item.dictValue"
                           :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="患者姓名" prop="patientName">
              <el-input v-model="form.patientName" clearable placeholder="请输入患者姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="中医证型" prop="tcmDiagnosis">
              <el-select v-model="form.tcmDiagnosis" clearable placeholder="请选择中医证型">
                <el-option v-for="item in dietSyndromeType"
                           :key="item.dictKey"
                           :label="item.dictValue" :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="账号状态" prop="accountStatus">
              <el-select v-model="form.accountStatus" clearable placeholder="请选择账号状态">
                <el-option v-for="item in $store.state.accountStatusDict"
                           :key="item.key"
                           :label="item.value"
                           :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="患者分组" prop="groupId">
              <el-select v-model="form.groupId" clearable placeholder="请选择患者分组">
                <el-option v-for="item in patientGroupingList"
                           :key="item.groupId"
                           :label="`${item.leaderName}的${item.name}`"
                           :value="item.groupId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="活动期程度" prop="activityLevel">
              <el-select v-model="form.activityLevel" clearable placeholder="请选择活动期程度">
                <el-option v-for="item in ibdSeverity"
                           :key="item.dictKey"
                           :label="item.dictValue"
                           :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="活动期病症" prop="activeDiseaseCondition">
              <el-select v-model="form.activeDiseaseCondition" clearable placeholder="请选择活动期病症">
                <el-option v-for="item in dietComplicationType"
                           :key="item.dictKey"
                           :label="item.dictValue"
                           :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="管理医生" prop="doctorId">
              <el-select v-model="form.doctorId" clearable placeholder="请选择管理医生">
                <el-option v-for="item in manageDoctorsList"
                           :key="item.id"
                           :label="item.docName"
                           :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="buttons" >
              <el-button type="primary" @click="query_handler" >查询</el-button>
              <el-button @click="reset_handler" >重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list">
      <el-table
          :data="table"
          style="width: 100%">
        <el-table-column
            prop="serialNumber"
            align="center"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="patientName"
            align="center"
            label="患者姓名">
        </el-table-column>
        <el-table-column
            prop="accountStatus"
            align="center"
            label="账号状态">
          <template #default="{ row }">
            <span :style="{ 'color' : accountStatusName(row.accountStatus).color || '' }" >{{ accountStatusName(row.accountStatus).value || "" }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="phone"
            align="center"
            label="手机号">
        </el-table-column>
        <el-table-column
            prop="gender"
            align="center"
            label="性别">
          <template #default="{ row }">
            <span>{{ genderName(row.gender) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="age"
            align="center"
            label="年龄">
          <template #default="{row}" >
            <span>{{ row.age ? `${row.age}岁` : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop=""
            align="center"
            label="身高/体重">
          <template #default="{row}">
            <span>{{ `${row.height}cm/${row.weight}kg` }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="bmi"
            align="center"
            label="BMI">
        </el-table-column>
        <el-table-column
            prop="diseaseStatusSummary"
            align="center"
            label="疾病状态">
        </el-table-column>
        <el-table-column
            prop="physicalLabor"
            align="center"
            label="体力劳动">
          <template #default="{row}" >
            <span>{{ physicalLaborName(row.physicalLabor) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="tcmDiagnosis"
            align="center"
            label="中医证型">
          <template #default="{row}" >
            <span>{{ tcmDiagnosisName(row.tcmDiagnosis) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="doctorName"
            align="center"
            label="管理医生">
        </el-table-column>
        <el-table-column
            prop="patientGroup"
            align="center"
            label="患者分组">
            <template #default="{row}" >
              <span>{{ `${row.doctorName}的${row.patientGroup}` }}</span>
            </template>
        </el-table-column>
        <el-table-column
            prop="foodAllergy"
            align="center"
            label="食物过敏史">
          <template #default="{ row }" >
            <el-link type="primary" @click="see_allergy(row)" >查看</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="dietaryTaboo"
            align="center"
            label="饮食禁忌">
          <template #default="{ row }" >
            <el-link type="primary" @click="see_taboo(row)" >查看</el-link>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            align="center"
            label="操作">
          <template #default="{ row }" >
            <div class="links" >
              <el-link type="primary" @click="link_details(row)" >对照数据</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <SeeAllergyTaboo v-model="see_data.show" :state="see_data.state" :text="see_data.text" />
  </div>
</template>

<script>
import SeeAllergyTaboo from "./components/SeeAllergyTaboo";
export default {
  name: "PatientManage",
  components: {SeeAllergyTaboo},
  data() {
    return {
      form: {
        diseaseStatus: "",
        diseaseSeverity: "",
        activityLevel: "",
        activeDiseaseCondition: "",
        patientName: "",
        accountStatus: "",
        tcmDiagnosis: "",
        doctorId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
      },
      table: [],
      total: 0,
      gender: [
        {
          key: 0,
          value: "女"
        },
        {
          key: 1,
          value: "男"
        }
      ],
      dietSyndromeType: [],
      dietActivityLevel: [],
      manageDoctorsList: [],
      patientGroupingList: [],
      dietIbdCategory: [],
      dietIbdStage: [],
      ibdSeverity: [],
      dietComplicationType: [],
      see_data: {
        show: false,
        state: "", // allergy 食物过敏史 taboo 饮食禁忌
        text: "",
      }
    }
  },
  computed: {
    accountStatusName() {
      return (e) => {
        const obj = (this.$store.state.accountStatusDict || []).find(item => item.key === e) || {};
        return obj;
      }
    },
    genderName() {
      return (e) => {
        const obj = (this.gender || []).find(item => item.key === e) || {};
        return obj.value || "";
      }
    },
    diseaseStatusName() {
      return (e) => {
        const obj = (this.gender || []).find(item => item.dictKey === e) || {};
        return obj.dictValue || "";
      }
    },
    physicalLaborName() {
      return (e) => {
        const obj = (this.dietActivityLevel || []).find(item => item.dictKey === e) || {};
        return obj.dictValue || "";
      }
    },
    tcmDiagnosisName() {
      return (e) => {
        const obj = (this.dietSyndromeType || []).find(item => item.dictKey === e) || {};
        return obj.dictValue || "";
      }
    },
  },
  created() {
    this.getDietIbdCategory();
    this.getDietIbdStage();
    this.getIbdSeverity();
    this.getDietComplicationType();
    this.getManageDoctorsList();
    this.getPatientGroupingList();
    this.getDietSyndromeType();
    this.getDietActivityLevel();
    this.getList();
  },
  mounted() {

  },
  methods: {
    query_handler() {
      this.form.pageNum = 1;
      this.getList();
    },
    reset_handler() {
      this.$refs.formRef.resetFields();
      this.getList();
    },
    async getDietIbdCategory() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_ibd_category"}`);
        if (!res) return false;
        const { data } = res;
        this.dietIbdCategory = data;
      }catch (e) {
        console.error(`疾病状态字典`, e);
      }
    },
    async getDietIbdStage() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_ibd_stage"}`);
        if (!res) return false;
        const { data } = res;
        this.dietIbdStage = data;
      }catch (e) {
        console.error(`疾病程度字典`, e);
      }
    },
    async getIbdSeverity() {
      try {
        const res = await this.$get(`dictionary/type/${"ibd_severity"}`);
        if (!res) return false;
        const { data } = res;
        this.ibdSeverity = data;
      }catch (e) {
        console.error(`活动期程度字典`, e);
      }
    },
    async getDietComplicationType() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_complication_type"}`);
        if (!res) return false;
        const { data } = res;
        this.dietComplicationType = data;
      }catch (e) {
        console.error(`活动期病症字典`, e);
      }
    },
    async getManageDoctorsList() {
      try {
        const res = await this.$get("gp/getNewDoctorList");
        if (!res) return false;
        const { data } = res;
        this.manageDoctorsList = data;
      }catch (e) {
        console.error(`获取管理医生字典失败`, e);
      }
    },
    async getPatientGroupingList() {
      try {
        const res = await this.$get('group/list',{
          docId: this.$store.state.doctor_id
        });
        if (!res) return false;
        const { data } = res;
        this.patientGroupingList = data;
      }catch (e) {
        console.error(`获取患者分组字典失败`, e);
      }
    },
    async getDietActivityLevel() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_activity_level"}`);
        if (!res) return false;
        const { data } = res;
        this.dietActivityLevel = data;
      }catch (e) {
        console.error(`体力劳动字典`, e);
      }
    },
    async getDietSyndromeType() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_syndrome_type"}`);
        if (!res) return false;
        const { data } = res;
        this.dietSyndromeType = data;
      }catch (e) {
        console.error(`中医证型字典`, e)
      }
    },
    async getList() {
      try {
        const res = await this.$post("diet/patient/getPatientDetail", {
          ...this.form,
          userId: this.$store.state.user_info?.userId || ''
        })
        if (!res) return false;
        const { data } = res;
        this.table = data.list;
        this.total = data.total;
      }catch (e) {
        console.error(`获取患者列表失败`, e)
      }
    },
    // 食物过敏史
    see_allergy(row) {
      this.see_data.text = row.foodAllergyName?.map(item => item.typeName).join(",");
      this.see_data.state = "allergy";
      this.see_data.show = true;
    },
    // 饮食禁忌
    see_taboo(row) {
      this.see_data.text = row.dietaryTabooName?.map(item => item.typeName).join(",");
      this.see_data.state = "taboo";
      this.see_data.show = true;
    },
    // 编辑
    link_details(row) {
      this.$router.push({
        path: '/PatientManageDetails',
        query: {
          patientOpenid: row.patientOpenid,
          patientName: row.patientName,
          accountStatus: row.accountStatus,
          phone: row.phone,
          gender: row.gender,
          age: row.age,
          doctorName: row.doctorName,
          patientGroup: row.patientGroup,
        }
      });
    },
    // 确定删除
    confirmEvent(row) {
      console.log(row);
    },
    // 取消删除
    cancelEvent() {

    },
    handleSizeChange(e) {
      this.form.pageSize= e;
      this.getList(this.form);
    },
    handleCurrentChange(e) {
      this.form.pageNum= e;
      this.getList(this.form);
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  .list{
    flex: 1;
    .add-button-class{
      width: 100px;
    }
  }
}
.buttons{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>

